// removed by extract-text-webpack-plugin
module.exports = {"resorts":"rQ2c","slider":"s0lq","item":"_2TIh","slide":"_3_kh","logo":"_30-a","innerSlide":"uCz1","img":"el4X","itemTitle":"_2BlS","textBox":"_6y89","title":"_18fu","blurb":"_9lEN","price":"_3T9s","goto":"_140Z","arrow":"L0kl","gold":"huD4","turquoise":"_10PV","textGold":"_1ZTb","iconDiamond":"_d65","textTurquoise":"_2vXF","subtitle":"_3zEL","dotnav":"_1w9B","activeDot":"_3Wv8","inactiveDot":"_2nq4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/resorts/sliderresorts/style.css
// module id = 392
// module chunks = 9